export default {"src":"/trader-new/_next/static/media/Rewards.e203ab63.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};